import React from 'react';
interface PriceDisplayProps {
  basePriceArs: number;
  isCrossedOut?: boolean;
  className?: string;
}
export function PriceDisplay({
  basePriceArs,
  isCrossedOut = false,
  className = ''
}: PriceDisplayProps) {
  const formattedPrice = `$${basePriceArs.toLocaleString('es-AR')}`;
  return <span className={`${isCrossedOut ? 'line-through opacity-60' : 'font-bold'} ${className}`} data-id="element-117">
      {formattedPrice}
    </span>;
}